(function () {
  var SALE_PRICE_CLASSES_ON_SALE = 'text-lg text-on-sale';
  var SALE_PRICE_CLASSES_REGULAR = 'text-lg';
  var COMPARE_AT_PRICE_CLASSES = 'text-subdued line-through';

  function getSrLabel(el, fallback) {
    var srOnly = el && el.querySelector('.sr-only');
    return (srOnly && srOnly.textContent) || fallback || '';
  }

  function setMoneyContent(el, html, srLabel) {
    if (!el) return;

    el.innerHTML = '';

    if (srLabel) {
      var sr = document.createElement('span');
      sr.className = 'sr-only';
      sr.textContent = srLabel;
      el.appendChild(sr);
    }

    var money = document.createElement('span');
    money.className = 'money';
    money.innerHTML = html;
    el.appendChild(money);
  }

  function updatePriceList(card, option) {
    var priceList = card.querySelector('price-list');
    if (!priceList || !option) return;

    var variantId = option.value || '';
    var price = option.getAttribute('data-price') || '0';
    var compareAtPrice = option.getAttribute('data-compare-at-price') || '0';
    var priceHtml = option.getAttribute('data-price-html') || '';
    var compareAtHtml = option.getAttribute('data-compare-at-html') || '';
    var onSale = option.getAttribute('data-on-sale') === 'true';
    var compareAtValue = parseInt(compareAtPrice, 10);
    var priceValue = parseInt(price, 10);
    var showCompareAt = onSale && compareAtValue > priceValue;

    var salePrice = priceList.querySelector('sale-price');
    if (!salePrice) {
      salePrice = document.createElement('sale-price');
      priceList.prepend(salePrice);
    }

    var saleSrLabel = getSrLabel(salePrice, 'Sale price');
    salePrice.className = showCompareAt ? SALE_PRICE_CLASSES_ON_SALE : SALE_PRICE_CLASSES_REGULAR;
    salePrice.setAttribute('data-price', price);
    salePrice.setAttribute('data-variant', variantId);
    salePrice.removeAttribute('data-exchanged-to');
    salePrice.setAttribute('data-force_exchange', '1');
    setMoneyContent(salePrice, priceHtml, saleSrLabel);

    var compareAtPriceEl = priceList.querySelector('compare-at-price');

    if (showCompareAt) {
      var compareSrLabel = getSrLabel(compareAtPriceEl, 'Regular price');

      if (!compareAtPriceEl) {
        compareAtPriceEl = document.createElement('compare-at-price');
        salePrice.insertAdjacentElement('afterend', compareAtPriceEl);
      }

      compareAtPriceEl.className = COMPARE_AT_PRICE_CLASSES;
      compareAtPriceEl.setAttribute('data-cprice', compareAtPrice);
      compareAtPriceEl.setAttribute('data-variant', variantId);
      compareAtPriceEl.removeAttribute('data-exchanged-to');
      compareAtPriceEl.setAttribute('data-force_exchange', '1');
      setMoneyContent(compareAtPriceEl, compareAtHtml, compareSrLabel);
    } else if (compareAtPriceEl) {
      compareAtPriceEl.remove();
    }

    document.dispatchEvent(new CustomEvent('effic:exchange_prices', { bubbles: true }));
  }

  function updateCardState(card, option) {
    if (!card || !option) return;

    var button = card.querySelector('[data-add-to-cart]');
    var buttonLabel = card.querySelector('[data-add-to-cart-label]');
    var available = option.getAttribute('data-available') === 'true';
    var addLabel = card.getAttribute('data-add-label') || 'Add to cart';
    var soldOutLabel = card.getAttribute('data-sold-out-label') || 'Out of stock';

    updatePriceList(card, option);

    if (button) {
      button.disabled = !available;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
      button.classList.toggle('is-sold-out', !available);
    }

    if (buttonLabel) {
      buttonLabel.textContent = available ? addLabel : soldOutLabel;
    }
  }

  function toggleDescription(description) {
    if (!description) return;

    var shortEl = description.querySelector('[data-description-short]');
    var fullEl = description.querySelector('[data-description-full]');
    if (!shortEl || !fullEl) return;

    var isExpanded = description.classList.toggle('is-expanded');
    description.classList.toggle('is-collapsed', !isExpanded);
    fullEl.hidden = !isExpanded;
    description.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    description.setAttribute('aria-label', isExpanded ? 'Show less description' : 'Show more description');
  }

  function initDescriptionToggle(description) {
    if (!description || description.dataset.descriptionReady === 'true') return;

    description.dataset.descriptionReady = 'true';

    function handleToggle(event) {
      if (event.target.closest('a, button, input, textarea, select, label')) return;

      event.preventDefault();
      event.stopPropagation();
      toggleDescription(description);
    }

    // Stop the mobile slider from capturing the pointer before click fires.
    description.addEventListener('pointerdown', function (event) {
      event.stopPropagation();
    });

    description.addEventListener('click', handleToggle);

    description.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      handleToggle(event);
    });
  }

  function initProductCard(card) {
    if (!card || card.dataset.sandsAddProductsReady === 'true') return;

    card.dataset.sandsAddProductsReady = 'true';

    var description = card.querySelector('[data-description]');
    if (description) initDescriptionToggle(description);

    var select = card.querySelector('[data-variant-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      updateCardState(card, option);
    });
  }

  function initSection(section) {
    if (!section) return;
    section.querySelectorAll('[data-product-card]').forEach(initProductCard);
  }

  function initAll() {
    document.querySelectorAll('[data-sands-add-products]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector('[data-sands-add-products]');
    if (section) initSection(section);
  });
})();
